import type { ComponentProps } from 'react'
import type * as MenuPrimitive from '@radix-ui/react-dropdown-menu'

import { createLazyComponent } from '@muse-web/router'

import { MenuPlaceholder, MenuTriggerPlaceholder } from './MenuPlaceholder'
import type { TMenuContentProps, TMenuItemProps, TMenuLabelProps } from './Menu.types'

const loadMenu = () => import(/* webpackChunkName: 'menu' */ './Menu')

export const Menu = createLazyComponent<ComponentProps<typeof MenuPrimitive.Root>, 'Menu'>(
    loadMenu,
    'Menu',
    { fallback: MenuPlaceholder },
)

export const MenuTrigger = createLazyComponent<
    ComponentProps<typeof MenuPrimitive.Trigger>,
    'MenuTrigger'
>(loadMenu, 'MenuTrigger', { fallback: MenuTriggerPlaceholder })

export const MenuPortal = createLazyComponent<
    ComponentProps<typeof MenuPrimitive.Portal>,
    'MenuPortal'
>(loadMenu, 'MenuPortal')

export const MenuContent = createLazyComponent<TMenuContentProps, 'MenuContent'>(
    loadMenu,
    'MenuContent',
)

export const MenuItem = createLazyComponent<TMenuItemProps, 'MenuItem'>(loadMenu, 'MenuItem')

export const MenuLabel = createLazyComponent<TMenuLabelProps, 'MenuLabel'>(loadMenu, 'MenuLabel')
